/*
 * SPDX-FileCopyrightText: 2020-2023 CERN.
 * SPDX-FileCopyrightText: 2020-2022 Northwestern University.
 * SPDX-License-Identifier: MIT
 */

export const CREATIBUTOR_TYPE = {
  PERSON: "personal",
  ORGANIZATION: "organizational",
};
